import { getType as originGetType } from 'typesafe-actions';
export * from 'typesafe-actions';

export const takeType = <T>(arg: T): T =>
  (originGetType(arg as any) as any) as T;
